(function () {
  'use strict';

  function initKeyFeatures(root) {
    var triggers = root.querySelectorAll('[data-key-features-trigger]');
    var images = root.querySelectorAll('[data-key-features-image]');

    if (!triggers.length || images.length < 2) return;

    // Track which of the two stacked image layers is currently on top.
    var frontIndex = 0;
    for (var i = 0; i < images.length; i++) {
      if (images[i].classList.contains('is-visible')) {
        frontIndex = i;
        break;
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        // Toggle active state on the list immediately
        triggers.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-selected', 'true');

        var newSrc = trigger.getAttribute('data-image');
        if (!newSrc) return;

        var frontImage = images[frontIndex];
        if (newSrc === frontImage.getAttribute('data-current-src')) return;

        var backIndex = frontIndex === 0 ? 1 : 0;
        var backImage = images[backIndex];

        // Load the new image into the back (hidden) layer
        backImage.src = newSrc;
        backImage.alt = trigger.getAttribute('data-image-alt') || '';
        backImage.setAttribute('data-current-src', newSrc);

        // Crossfade: back layer fades in + grows, front layer fades out + shrinks,
        // at the same time, so they blend into each other instead of a hard cut.
        backImage.classList.add('is-visible');
        frontImage.classList.remove('is-visible');

        frontIndex = backIndex;
      });
    });

    // Record the initial front image's src so the first real click can
    // compare against it correctly.
    images[frontIndex].setAttribute('data-current-src', images[frontIndex].getAttribute('src'));
  }

  function initAll() {
    document.querySelectorAll('[data-key-features]').forEach(initKeyFeatures);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // Re-init when a block/section is added or re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-key-features]');
    if (section) initKeyFeatures(section);
  });
})();